<template>
    <div>
        <Nota v-if="isnota" v-on:shownota="shownota" v-on:isdetailsetnota="isdetailsetnota" v-bind:datanota="datanota"
              v-bind:datatextnota="datatextnota" v-bind:setidoutletsetnota="setidoutlet" v-on:gototextnota="shownotatext"
              v-on:getnota="getnota" ref="datanota"/>
        <NotaText v-if="isnotatext" v-on:shownotatext="shownotatext" v-on:shownota="shownota" v-on:setnota="setisinota" v-bind:setidoutletsetnota="setidoutlet" v-bind:datatextnota="datatextnota" ref="datanotatext"/>
    </div>
</template>

<script>
    import Nota from "../../onboarding/Nota";
    import NotaText from "../../onboarding/NotaText";
    export default {
        name: "SetNota",
        props:['setidoutlet'],
        components:{
            Nota,NotaText
        },
        data(){
            return{
                isnota:false,
                isnotatext:false,
                idoutlet:this.setidoutlet,
                tipe:'',


                datanota:{
                    tipe:'',
                    outlet:{},
                    checkednota:0,
                },
                datatextnota:{
                    namepage:'',
                    posturl:'',
                    variableupdate:'',
                    textpage:'',
                },
	            requestHeaders: {
		            headers: {
			            'Authorization': 'Bearer ' + localStorage.getItem('token'),
		            }
	            },
            }
        },
        mounted() {
            this.shownota();
            document.documentElement.scrollTop = 0;
        },
        methods:{
        	notaType(type) {
        		switch (type) {
        			case 1 :
				        this.datatextnota.namapage="Nota Transaksi"
				        this.datatextnota.posturl = "masterData/outlet/update_nota_transaksi?idoutlet="
				        this.datatextnota.variableupdate= 'nota_transaksi'
				        break
			        case 2 :
				        this.datatextnota.namapage="Nota Pembelian Deposit"
				        this.datatextnota.posturl = "masterData/outlet/update_nota_pembelian_deposit?idoutlet="
				        this.datatextnota.variableupdate= 'nota_beli_deposit'
				        break
			        case 3 :
				        this.datatextnota.namapage="Nota Pembelian E-Payment"
				        this.datatextnota.posturl = "masterData/outlet/update_nota_epayment?idoutlet="
				        this.datatextnota.variableupdate= 'nota_beli_emoney'
				        break
			        case 4 :
				        this.datatextnota.namapage="Nota Penjemputan dari Konsumen"
				        this.datatextnota.posturl = "masterData/outlet/update_nota_penjemputan_konsumen?idoutlet="
				        this.datatextnota.variableupdate= 'nota_surat_jemput'
				        break
			        case 5 :
				        this.datatextnota.namapage="Nota Pembelian Paylink"
				        this.datatextnota.posturl = "masterData/outlet/update_nota_topup_paylink?idoutlet="
				        this.datatextnota.variableupdate= 'nota_topup_paylink'
				        break
			        case 6 :
				        this.datatextnota.namapage="Nota Pendaftaran Member"
				        this.datatextnota.posturl = "masterData/outlet/update_nota_pendaftaran_member?idoutlet="
				        this.datatextnota.variableupdate= 'nota_daftar_member'
				        break
			        case 7 :
				        this.datatextnota.namapage="Surat Pengantaran"
				        this.datatextnota.posturl = "masterData/outlet/update_nota_pengantaran_konsumen?idoutlet="
				        this.datatextnota.variableupdate= 'nota_surat_antar'
				        break
			        case 8 :
				        this.datatextnota.namapage="Surat Pengantaran ke Workshop"
				        this.datatextnota.posturl = "masterData/outlet/update_nota_pengantaran_ws?idoutlet="
				        this.datatextnota.variableupdate= 'nota_surat_antar_workshop'
				        break
			        case 9 :
				        this.datatextnota.namapage="Surat Penjemputan ke Workshop"
				        this.datatextnota.posturl = "masterData/outlet/update_nota_penjemputan_ws?idoutlet="
				        this.datatextnota.variableupdate= 'nota_surat_jemput_workshop'
		        }
	        },
        	
            setisinota(){
        		this.notaType(this.datanota.tipe)
            },

            shownota(){
                this.isnota=true;
                this.isnotatext=false;
                this.getnota()

            },
            shownotatext(tipe){
                setTimeout(() => {
                    this.isnota=false;
                    this.isnotatext=true;
                    this.datanota.tipe=tipe;
                    this.notaType(this.datanota.tipe)
                    if(this.datanota.tipe===1){
                        this.$refs.datanota.getnotatransaksinotattext()
                    }else if(this.datanota.tipe===2){
                        this.$refs.datanota.getnotadeposit()
                    }else if(this.datanota.tipe===3){
                        this.$refs.datanota.getnotaepayment()
                    }else if(this.datanota.tipe===4){
                        this.$refs.datanota.getnotapenjemputankonsumen()
                    }else if(this.datanota.tipe===5){
                        this.$refs.datanota.getnotapaylink()
                    }else if(this.datanota.tipe===6){
                        this.$refs.datanota.getnotamember()
                    }else if(this.datanota.tipe===7){
                        this.$refs.datanota.getsuratpengantaran()
                    }else if(this.datanota.tipe===8){
                        this.$refs.datanota.getsuratpengantarwk()
                    }else if(this.datanota.tipe===9){
                        this.$refs.datanota.getsuratpengambilanwk()
                    }
                },500)

            },

            isdetailsetnota(){
                this.$emit('isdetail')
            },



            async getnota(){
                this.backButtonPressed(this.$refs.datanota.back)

                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                	var idoutlet = ""
                	if (this.setidoutlet.idoutlet !== undefined) {
		                idoutlet = this.setidoutlet.idoutlet
	                } else {
		                idoutlet = this.setidoutlet
	                }
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_outlet_meta?idoutlet=' + idoutlet, this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.datanota.outlet = response.data.data[0]
                    } else {
                    	this.$toast.error(response.data.msg)
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },



        }
    }
</script>

<style scoped>

</style>